import { useLayoutEffect } from 'react';
import styled from 'styled-components';

export const PAYMENT_FINALIZED = '3DSFinalized';

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: ${({ theme }) => theme.palette.white};
  z-index: ${({ theme }) => theme.zIndex.popup};
`;

export const Payment3DSFinalized = (): JSX.Element => {
  useLayoutEffect(() => {
    window.parent.postMessage({ type: PAYMENT_FINALIZED }, '*');
  }, []);

  return <Overlay />;
};
